import "./core/devSeed"; // DEV-only автологин: ДОЛЖЕН идти первым
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';
import ReactGA from 'react-ga';
import App from "./App";
import store from "redux/store";
import "./core/i18n";
import { handleGoogleRedirectEarly } from "utils/helpers/googlePopupAuth";

if (process.env.REACT_APP_ENV_MODE !== "development") {
  window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-WELHTH885C");
}


process.env.REACT_APP_ENV_MODE !== "development" && ReactGA.initialize('G-WELHTH885C');
process.env.REACT_APP_ENV_MODE !== "development" && ReactGA.pageview(window.location.pathname + window.location.search);

window.datesArr = []

const googleClientId = process.env.REACT_APP_GOOGLE_ID
  ? `${process.env.REACT_APP_GOOGLE_ID}.apps.googleusercontent.com`
  : "";

// Окно-попап входа Google (ответ OAuth в хэше): приложение не рендерим.
if (!handleGoogleRedirectEarly()) ReactDOM.render(
  <Provider store={store}>
    <Router>
        <GoogleOAuthProvider clientId={googleClientId}>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </GoogleOAuthProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);
